<template>
	<div id="app">
		<router-view v-cloak v-transition v-wechat-title='$route.meta.title' class="rich-view"></router-view>
	</div>
</template>

<script>
import { addClass } from '@/utils/index.js'
import { mapState, mapMutations, mapActions } from 'vuex' // vuex状态管理器，主要使用store/index.js

export default {
  name: 'app',
  components: {
  },
  computed: {
    isLogin () {
      return this.$store.state.server.isLogin
    },
    vPid () {
      return this.$store.state.server.vPid
    }
  },
  data () {
    return {}
  },
  methods: {
    ...mapMutations([
      'setIsLogin'
    ])
  },
  mounted () {
    this.downloaded = this.$local.get('appOs') != '1' && this.ifDownload
    //    如果是安卓的机器就添加该字体
    this.$nextTick(() => {
      if (os === 'AndroidOS') {
        addClass(document.documentElement, 'androidHtml')
      } else {
        addClass(document.documentElement, 'otherHtml')
      }
    })
    if (Cookie.get('keyCode')) {
      this.setIsLogin(true)
    } else {
      this.setIsLogin(false)
    }
  }

}
</script>
<style lang="less">
@import './common/font/font.css';
.downloadFixed {
  position: fixed;
  z-index: 6999;
  top: 1.2rem;
  right: .6rem;
}
.downloadFixed img {
  width: 2.08rem;
}
.closeDownload {
  position: fixed;
  z-index: 6999;
  top: 1rem;
  right: .2rem;
}
.closeDownload img {
  width: .4rem;
}
.van-toast--bottom {
  border-radius: .1rem;
  text-align: center;
}
.select-text {
  -webkit-user-select:all;
  -moz-user-select:all;
  -ms-user-select:all;
  user-select:all;
}
</style>



// WEBPACK FOOTER //
// src/App.vue